export default __webpack_public_path__ + "static/media/em_hoodie_1.a9d2e7f5.webp";